import { Component, inject } from '@angular/core';
import { MyOffersService } from './services/my-offers.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { OccEndpointsService } from '@spartacus/core';
import { combineLatest, tap } from 'rxjs';
import { DataLayerService } from '../shared/services/data-layer.service';

@Component({
  selector: 'app-my-offers',
  templateUrl: './my-offers.component.html',
  styleUrl: './my-offers.component.scss',
})
export class MyOffersComponent {
  private readonly myOffersService = inject(MyOffersService);
  private readonly occEndpointService = inject(OccEndpointsService);
  private readonly dataLayerService = inject(DataLayerService);

  readonly baseurl = this.occEndpointService.getBaseUrl({
    baseUrl: true,
    prefix: false,
    baseSite: false,
  });

  private readonly vm$ = combineLatest({
    offers: this.myOffersService.offers$,
    user: this.myOffersService.user$,
  }).pipe(
    tap(({ offers }) => {
      if (offers.length === 0) {
        this.dataLayerService.addtoDataLayer(
          'offerForm_FormEvent',
          {
            error_type: `Unfortunately, this offer is unavailable for your selected location. Please select a different location to check for eligibility.`,
          },
          null,
          null,
          'form_error'
        );
      }
    })
  );

  readonly vm = toSignal(this.vm$);
}
